import { VulnerabilityV2 } from '../VulnerabilityV2/VulnerabilityV2';

export default function VulnerabilityPage() {
  return <VulnerabilityV2 />;
}
